import {
  INCOME_FREQUENCY_LABEL,
  INCOME_FREQUENCY_OPTIONS,
  MARITAL_STATUSES_LABEL,
  PREFERRED_SALUTATION_LABEL,
} from "../applicant.const";
import { LIVING_SITUATION_LABELS } from "../application.const";
import {
  GARAGE_TYPES_LABEL,
  HEATING_TYPES_LABEL,
  PROPERTY_STYLES_LABEL,
  PROPERTY_TENURE_LABEL,
  PROPERTY_TYPES_LABEL,
  SUBJECT_PROPERTY_PURPOSE_LABEL,
} from "../property.const";

import { useTypesOverrideOptions } from "./useTypesOverrideOptions";

export const useMaritalStatusOptions = () =>
  useTypesOverrideOptions({
    settingKey: "maritalStatusTypes",
    labelMap: MARITAL_STATUSES_LABEL,
  });

export const usePreferredSalutationOptions = () =>
  useTypesOverrideOptions({
    settingKey: "preferredSalutationTypes",
    labelMap: PREFERRED_SALUTATION_LABEL,
  });

export const useResidentialSituationOptions = () =>
  useTypesOverrideOptions({
    settingKey: "residentialSituationTypes",
    labelMap: LIVING_SITUATION_LABELS,
  });

export const useIncomeFrequencyOptions = () =>
  useTypesOverrideOptions({
    settingKey: "incomeFrequencyTypes",
    labelMap: INCOME_FREQUENCY_LABEL,
    defaultValue: INCOME_FREQUENCY_OPTIONS,
    translate: false,
  });

export const usePropertyPurposeOptions = () =>
  useTypesOverrideOptions({
    settingKey: "subjectPropertyPurposeTypes",
    labelMap: SUBJECT_PROPERTY_PURPOSE_LABEL,
  });

export const usePropertyTypeOptions = () =>
  useTypesOverrideOptions({
    settingKey: "propertyTypes",
    labelMap: PROPERTY_TYPES_LABEL,
  });

export const usePropertyStyleOptions = () =>
  useTypesOverrideOptions({
    settingKey: "propertyStyles",
    labelMap: PROPERTY_STYLES_LABEL,
  });

export const usePropertyTenureOptions = () =>
  useTypesOverrideOptions({
    settingKey: "propertyTenureTypes",
    labelMap: PROPERTY_TENURE_LABEL,
  });

export const useHeatingTypeOptions = () =>
  useTypesOverrideOptions({
    settingKey: "heatingTypes",
    labelMap: HEATING_TYPES_LABEL,
  });

export const useGarageTypeOptions = () =>
  useTypesOverrideOptions({
    settingKey: "garageTypes",
    labelMap: GARAGE_TYPES_LABEL,
  });
